// @flow

import styled from 'styled-components';

export const ErrorLabel = styled.span`
  color: ${props => props.theme.colors.error(51)};
  font-size: 0.9rem;
  font-weight: bold;
  margin-top: 0.1rem;
`;
